<div class="animated fadeIn relative full-width">
  <div class="relative">
    <input class="form-control full-width b-radius" #dateInput type="text" style="padding: 8px 35px 8px 8px;"
      [value]="selectedDate" (click)="toggleCalendar()" (keyup)="updateSelectedDate(dateInput.value)"
      [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]" pTooltip="{{settings.dateFormatSetting}}"
      tooltipPosition="top" />
    <fa-icon [icon]="faCalendar" class="absolute font13 calendar-icon"
      [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" (click)="toggleCalendar()"></fa-icon>
  </div>
  <ng-template [ngIf]="isCalendarVisible">
    <div class="calendar b-radius box-shadow"
      [ngClass]="action && action.type == 'MultiParamGridAction' ? '' : absolute">
      <div [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'" class="padding10">
        <div class="flex align-centre calendar-header">
          <fa-icon [icon]="faArrowLeft" class="font13 cursorPointer" (click)="previous()"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
          <span class="cursorPointer" (click)="showMonthView()"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{ monthNames[currentMonth] }} 
          </span>
          <span class="cursorPointer" (click)="showYearView()"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
            {{ currentYear }}
          </span>
          <fa-icon [icon]="faArrowRight" class="font13 cursorPointer" (click)="next()"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
        </div>
        <div class="calendar-grid" *ngIf="viewMode === 'days'">
          <div class="display-content day-names">
            <div *ngFor="let dayName of dayNames">
              <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{ dayName }}</span>
            </div>
          </div>
          <div class="padding5 text-centre cursorPointer b-radius display-content">
            <div *ngFor="let day of days" [class.empty]="day === null" (click)="day && selectDay(day)">
              <span class="cursorPointer" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{ day ? day.getDate() : '' }}
              </span>
            </div>
          </div>
        </div>
        <div class="month-grid padding5 text-centre cursorPointer b-radius" *ngIf="viewMode === 'months'">
          <div *ngFor="let month of monthNames; let i = index" 
              [ngClass]="{
                'bg-dark-secondary': settings.darkModeSetting && i === currentMonth,
                'bg-light-blue': !settings.darkModeSetting && i === currentMonth
              }"
            (click)="selectMonth(i)" style="transition: 0.2s;" class="padding5 b-radius cursorPointer text-centre">
            <span class="cursorPointer" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
              {{ month }}
            </span>
          </div>
        </div>
        <div class="year-grid padding5 text-centre cursorPointer b-radius" *ngIf="viewMode === 'years'">
          <div *ngFor="let year of yearRange"  (click)="selectYear(year)"
              [ngClass]="{
                'bg-dark-secondary': settings.darkModeSetting && year === currentYear,
                'bg-light-blue': !settings.darkModeSetting && year === currentYear
              }"
            style="transition: 0.2s;" class="padding5 b-radius cursorPointer text-centre">
            <span class="cursorPointer" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
              {{ year }}
            </span>
          </div>
        </div>
        <div class="today-footer cursorPointer text-centre">
          <button (click)="selectToday()" class=" b-radius"
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.LBL_Today}}</button>
        </div>
      </div>
    </div>
  </ng-template>
</div>